import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import { getPolicyStatusLabel } from 'core/helpers/policy-status';
import { IconButtonWithTooltip } from 'core/components/icon-button-with-tooltip';
import assignPolicyIcon from 'core/assets/svg/ic-assign-to-policy.svg';
import useStyles from './assign-policy-menu.styles';

const AssignPolicyMenu = ({ policies, currentPolicyId, onAssign, iconClassName, imgClassName }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const options = policies.map((policy) => ({
    id: policy.id,
    value: `${policy.id} · ${getPolicyStatusLabel(policy)}`
  }));

  const handleSelect = (policyId) => {
    setAnchorEl(null);
    if (policyId !== (currentPolicyId || '')) {
      onAssign(policyId);
    }
  };

  return (
    <>
      <IconButtonWithTooltip
        tooltip="Assign to policy"
        onClick={(event) => setAnchorEl(event.currentTarget)}
        icon={assignPolicyIcon}
        alt="assign document to policy"
        iconClassName={iconClassName}
        imgClassName={imgClassName}
      />
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        {currentPolicyId ? (
          <MenuItem className={classes.menuItem} onClick={() => handleSelect('')}>
            N/A (unassign)
          </MenuItem>
        ) : null}
        {options.map((option) => (
          <MenuItem
            key={option.id}
            className={classes.menuItem}
            selected={option.id === currentPolicyId}
            onClick={() => handleSelect(option.id)}
          >
            {option.value}
          </MenuItem>
        ))}
        {options.length === 0 ? (
          <MenuItem className={classes.menuItem} disabled>
            No policies on this account
          </MenuItem>
        ) : null}
      </Menu>
    </>
  );
};

AssignPolicyMenu.propTypes = {
  policies: PropTypes.array,
  currentPolicyId: PropTypes.string,
  onAssign: PropTypes.func.isRequired,
  iconClassName: PropTypes.string,
  imgClassName: PropTypes.string
};

AssignPolicyMenu.defaultProps = {
  policies: [],
  currentPolicyId: '',
  iconClassName: undefined,
  imgClassName: undefined
};

export default AssignPolicyMenu;
